import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ComponentType } from 'react';

import { editSpot } from '../spotsActions';
import { EditSpotData } from '../spotsTypes';

export function withEditSpot(WrappedComponent: ComponentType) {
  function mapDispatchToProps(dispatch: Dispatch) {
    return {
      editSpot: (spotId: string, data: EditSpotData, sendEvent?: (boolean) => void) => {
        dispatch(editSpot({ spotId, data, sendEvent }));
      }
    };
  }

  const ConnectedComponent = connect(null, mapDispatchToProps)(WrappedComponent);

  return ConnectedComponent;
}
